import { FiPenTool } from "react-icons/fi";
import { FaLaptopCode } from "react-icons/fa";
import { BsBarChartLine } from "react-icons/bs";
import { MdOutlineScience } from "react-icons/md";

import courses1 from "./assets/courses1.jpg";
import courses2 from "./assets/courses2.jpg";
import courses3 from "./assets/courses3.jpg";
import courses4 from "./assets/courses4.jpg";
import courses5 from "./assets/courses5.jpg";
import courses6 from "./assets/courses6.jpg";
import courses7 from "./assets/courses7.jpg";
import courses8 from "./assets/courses8.jpg";


import mtzlogo from "./assets/mtzlogo.png";

export const logo = [mtzlogo];
export const navLinks = [
  {
    id: 1,
    href: "home",
    link: "Home",
  },
  {
    id: 2,
    href: "about",
    link: "About",
  },
  {
    id: 3,
    href: "courses",
    link: "Courses",
  },
  {
    id: 4,
    href: "teacher",
    link: "Teacher",
  },
  {
    id: 5,
    href: "contact",
    link: "Contact",
  },
];

export const categories = [
  {
    id: 1,
    icon: <FiPenTool />,
    category: "Design",
  },
  {
    id: 2,
    icon: <FaLaptopCode />,
    category: "Development",
  },
  {
    id: 3,
    icon: <BsBarChartLine />,
    category: "Business",
  },
  {
    id: 4,
    icon: <MdOutlineScience />,
    category: "Science",
  },
];

export const courses = [
  {
    id: 1,
    image: courses1,
    title: "Our Founder",
  },
  {
    id: 2,
    image: courses2,
    title: "Beautifull momments",
  },
  {
    id: 3,
    image: courses3,
    title: "Heartwarming Picture",
  },
  {
    id: 4,
    image: courses4,
    title: "Anual function",
  },
  {
    id: 5,
    image: courses5,
    title: "Honerable Student",
  },
  {
    id: 6,
    image: courses6,
    title: "most poppular",
  },
  {
    id: 7,
    image: courses7,
    title: "Beautifull momments",
  },
  {
    id: 8,
    image: courses8,
    title: "Honerable Student",
  },
];

export const accordions = [
  {
    id: 1,
    title: "What is MTZIC Education?",
    about:
      "MTZIC Education is a sanctuary of learning, where dreams take flight and aspirations find wings to soar. It's a symphony of knowledge, harmonizing expertise with passion, guiding students towards academic brilliance and personal growth. ",
  },
  {
    id: 2,
    title: "What can I learn from MTZIC Education?",
    about:" MTZIC Education aims to provide comprehensive learning experiences in these subjects, led by expert instructors and tailored to meet the diverse needs of students. Whether you're preparing for exams, seeking personal enrichment, or enhancing your skills, MTZIC Education offers a platform for continuous learning and growth.",
  },
  {
    id: 3,
    title: "Can I teach on MTZIC Education?",
    about:"To determine if you can teach on MTZIC Education, you would typically need to go through their application or hiring process. Many educational platforms and institutions have specific requirements and criteria for selecting instructors. These may include educational qualifications, teaching experience, subject expertise, and sometimes additional assessments or interviews. you can usually start by visiting their website or contacting them directly to inquire about their application process for instructors. They may provide information on how to submit your qualifications, experience, and possibly any teaching demos or samples of your work.",
  },
  {
    id: 4,
    title: "What is included in my MTZIC Education membership?",
    about:"As an MTZIC Education member, you typically gain access to a range of benefits and resources designed to support your learning journey. While specific offerings may vary depending on the membership level and the platform's policies."
  },
];
export const techdetails = [
  {
    id: 1,
    title: "What is MTZIC Education?",
    about:
      "MTZIC Education is a sanctuary of learning, where dreams take flight and aspirations find wings to soar. It's a symphony of knowledge, harmonizing expertise with passion, guiding students towards academic brilliance and personal growth. ",
  },
];
